var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersPlain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_996_60704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.7998V19.7998C17.5 18.7389 17.0786 17.7215 16.3284 16.9714C15.5783 16.2212 14.5609 15.7998 13.5 15.7998H5.5C4.43913 15.7998 3.42172 16.2212 2.67157 16.9714C1.92143 17.7215 1.5 18.7389 1.5 19.7998V21.7998",
    stroke: "#86898F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.7998C11.7091 11.7998 13.5 10.0089 13.5 7.7998C13.5 5.59067 11.7091 3.7998 9.5 3.7998C7.29086 3.7998 5.5 5.59067 5.5 7.7998C5.5 10.0089 7.29086 11.7998 9.5 11.7998Z",
    stroke: "#86898F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 21.7997V19.7997C23.4993 18.9134 23.2044 18.0525 22.6614 17.352C22.1184 16.6515 21.3581 16.1513 20.5 15.9297",
    stroke: "#86898F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.92969C17.3604 4.14999 18.123 4.65039 18.6676 5.352C19.2122 6.05361 19.5078 6.91652 19.5078 7.80469C19.5078 8.69286 19.2122 9.55577 18.6676 10.2574C18.123 10.959 17.3604 11.4594 16.5 11.6797",
    stroke: "#86898F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_996_60704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.799805)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersPlain);
export default __webpack_public_path__ + "static/media/users_plain.173404517b32513e9e12ee115a996854.svg";
export { ForwardRef as ReactComponent };